import React, { Fragment, useEffect, useState } from "react";
import LocationIcon from "../../assets/img/orders/locationIcon.png";

import { CONSTANTS } from "config/constant";
import { Button, Card, Col, Modal, Row, Select } from "antd";
import EditIcon from "../../assets/img/orders/Edit.png";
import minusIcon from "../../assets/img/orders/minusIcon.png";
import plusIcon from "../../assets/img/orders/plusIcon.png";
import collectionDate from "../../assets/img/orders/collectionDate.png";
import deliverytimes from "../../assets/img/orders/deliverytime.png";
import editdeleivery from "../../assets/img/orders/editdeleivery.png";
import { UseUser } from "config/selectedUserContext";
import { UseItemList } from "config/itemListContext";
import { API_DELIVERY_ORDER } from "api/order-management";
import { API_COUPEN_ORDER } from "api/order-management";
import { toast } from "react-toastify";
import { Option } from "antd/es/mentions";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_LIST_STORE } from "api/store-managemnt";
import CalendarSlot from "components/Modal/CalendarSlot";
import { useNavigate } from "react-router-dom";

import cashondelivery from "../../assets/img/orders/cashondelivery.png";
// import cashondelivery from "../../assets";
import userplace from "../../assets/img/orders/orderDetail/userplace.png";

import creditCard from "../../assets/img/orders/credit.png";
import handonCash from "../../assets/img/orders/handonCash.png";
import moment from "moment";
import { API_PAYMENT_ORDER } from "api/order-management";
import { UseItemNotes } from "config/Notes";
import { API_GET_ORDER } from "api/order-management";
import { useParams } from "react-router-dom";
import EditOrderUser from "views/admin/orderManagement/OrderUser/EditOrderUser";
import DetailModalCardEdit from "components/Modal/DetailModalCardEdit";
import { API_UPDATE_ORDER } from "api/order-management";
import { TiDelete } from "react-icons/ti";
import CalendarSlotDelivery from "components/Modal/CalendarSlotDelivery";
import { API_CALCULATE_AMOUNT } from "api/order-management";
import { useTranslation } from "react-i18next";
const OrderCardEdit = ({
  itemCounts,
  setItemCounts,
  totalPrice,
  setTotalPrice,
  catagory,
  selectedOrderType,
  setSelectedOrderType,
  setCatagory,
  EditData,
  deliveryTimes,
}) => {
  const { selectUser, selectedUser } = UseUser();
  const { alItemsList, setAllitemsList } = UseItemList();
  const [data, setData] = useState([]);
  const [dataStore, setDataStore] = useState([]);

  const [deliveryTime, setDeliveryTime] = useState(null);
  const [pickUpTime, setPickUpTime] = useState(null);
  const [slotVisibleDelvery, setSlotVisibleDelvery] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [modalVisibleUser, setModalVisibleUser] = useState(false);
  const [slotVisible, setSlotVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // const [itemsList, setItemsList] = useState([]);
  // const [itemCounts, setItemCounts] = useState({});
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [coupenVisible, setCoupenVisible] = useState(false);
  // const [totalPrice, setTotalPrice] = useState(0); // State to hold total price
  const [totalItems, setTotalItems] = useState(0); // State for total number of items
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [tax, setTax] = useState(0);
  const [orderNote, setOrderNote] = useState("");

  const [coupenCode, setCoupenCode] = useState("");
  const [coupenData, setCoupenData] = useState("");
  const [applyCoupen, setApplyCoupen] = useState(false);
const {t} = useTranslation();
  const [selectedCustmerType, setSelectedCustmerType] = useState(null);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(null);
  const [orderId, setOrderId] = useState("");
  // const [itemNotes, setItemNotes] = useState({});
  const [selectedOptionUser, setSelectedOptionUser] = useState(null);
  const [selectedOptionUserStore, setSelectedOptionUserStore] = useState(null);
  const [discount, setDiscount] = useState(null);

  const [mainLaundry, setMainLaundry] = useState("");
  const [store, setStore] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentInfo, setPaymentInfo] = useState({
    amountDue: 0,
    amountPaid: 0,
    deliveryFee: 0,
    discount: 0,
    subtotal: 0,
    taxAmount: 0,
    totalAmount: 0,
  });

  const { updateNote, itemNotes } = UseItemNotes();
  let { id } = useParams();
  const Navigate = useNavigate();
  const handleRadioChange = (event) => {
    setPaymentMethod(event.target.value);
    if (event.target.value === "hand_cash") {
      setSelectedPaymentStatus("paid");
    } else {
      setSelectedPaymentStatus("unpaid");
    }
  };
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });

  const [paginationStore, setPaginationStore] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });

  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState();

  const [loadingLaundry, setLoadingLaundry] = useState(false);

  const [loadingorder, setLoadingOrder] = useState(false);

  const [loadingStore, setLoadingStore] = useState(false);

  const handleCheckboxChange = (option) => {
    if (selectedCustmerType === option) {
      setSelectedCustmerType(null); // Uncheck if already selected
    } else {
      setSelectedCustmerType(option); // Check the selected option
    }
  };
  const handleCheckboxChangeStatus = (option) => {
    if (selectedPaymentStatus === option) {
      setSelectedPaymentStatus(null); // Uncheck if already selected
    } else {
      setSelectedPaymentStatus(option); // Check the selected option
    }
  };

  const handleCardClick = (item) => {
    console.log("item click", item);
    setSelectedItem(item);
    setIsModalVisible(true);
  };
  // const handleConfirm = (time) => {
  //   console.log("Selected Delivery Time:", time);
  //   if (slotVisibleDelvery === true) {
  //     if (time) {
  //       setDeliveryTime(time);
  //       setSlotVisibleDelvery(false);
  //     }
  //   } else {
  //     if (slotVisible === true) {
  //       if (time) {
  //         setPickUpTime(time);
  //         setSlotVisible(false);
  //       }
  //     }
  //   }
  // };

  const handleConfirm = (time) => {
    console.log("Selected Delivery Time:", time);
    if (slotVisibleDelvery === true) {
      if (time) {
        setDeliveryTime(time);
        setPickUpTime(time);

        setSlotVisibleDelvery(false);
      }
    } else {
      if (slotVisible === true) {
        if (time) {
          setPickUpTime(time);
          setSlotVisible(false);
        }
      }
    }
  };
  const handleRemoveClick = (item) => {
    setAllitemsList((prevSelectedItems) =>
      prevSelectedItems.filter((selected) => selected._id !== item._id)
    );

    // Remove item counts for the removed item
    setItemCounts((prevItemCounts) => {
      const updatedCounts = { ...prevItemCounts };
      item.item_service.forEach((service) => {
        delete updatedCounts[service._id];
      });
      return updatedCounts;
    });
    setIsDeleteModalVisible(false);
  };
  const calculateTotalQuantity = (item) => {
    return item?.item_info
      ? item?.item_info?.item_service.reduce((total, service) => {
          const key = `${item._id}_${service._id}`;
          return total + (itemCounts[key] || Number(service.quantity) || 0);
        }, 0)
      : item?.item_service.reduce((total, service) => {
          const key = `${item._id}_${service._id}`;
          return total + (itemCounts[key] || Number(service.quantity) || 0);
        }, 0);
  };
  const calculateTotalPrice = (item) => {
    return item?.item_info
      ? item?.item_info?.item_service.reduce((total, service) => {
          const key = `${item._id}_${service._id}`;
          const quantity = itemCounts[key] || Number(service.quantity) || 0;
          const price = service.price ? parseFloat(service.price) : 0;
          return total + quantity * price;
        }, 0)
      : item?.item_service.reduce((total, service) => {
          const key = `${item._id}_${service._id}`;
          const quantity = itemCounts[key] || Number(service.quantity) || 0;
          const price = service.price ? parseFloat(service.price) : 0;
          return total + quantity * price;
        }, 0);
  };

  // const calculateTotalQuantity = (item) => {
  //   return item?.item_info
  //     ? item?.item_info?.item_service.reduce((total, service) => {
  //         return (
  //           total + (itemCounts[service._id] || Number(service.quantity) || 0)
  //         );
  //       }, 0)
  //     : item?.item_service.reduce((total, service) => {
  //         return (
  //           total + (itemCounts[service._id] || Number(service.quantity) || 0)
  //         );
  //       }, 0);
  // };

  // const calculateTotalPrice = (item) => {
  //   return item?.item_info
  //     ? item?.item_info?.item_service.reduce((total, service) => {
  //         const quantity =
  //           itemCounts[service._id] || Number(service.quantity) || 0;
  //         const price = service.price ? parseFloat(service.price) : 0;
  //         return total + quantity * price;
  //       }, 0)
  //     : item?.item_service.reduce((total, service) => {
  //         const quantity =
  //           itemCounts[service._id] || Number(service.quantity) || 0;
  //         const price = service.price ? parseFloat(service.price) : 0;
  //         return total + quantity * price;
  //       }, 0);
  // };

  // const calculateTotalPrice = (item) => {
  //   console.log("item cal", item);
  //   const total = item?.item_service?.reduce(
  //     (total, service) => total + Number(service?.price),
  //     0
  //   );
  //   const itemCount = itemCounts[item._id] || 1;
  //   return total * itemCount;
  // };

  // const handleCountMinus = (item) => {
  //   console.log("plus minus", item);

  //   setItemCounts((prevItemCounts) => {
  //     const newCount = (prevItemCounts[item._id] || 1) - 1;
  //     if (newCount < 1) return prevItemCounts; // Prevent count from going below 1
  //     return {
  //       ...prevItemCounts,
  //       [item._id]: newCount,
  //     };
  //   });
  // };
  const handleCountMinus = ({ itemId, serviceId, count }) => {
    const key = `${itemId}_${serviceId}`;
    setItemCounts((prevItemCounts) => ({
      ...prevItemCounts,
      [key]: Math.max((prevItemCounts[key] || Number(count)) - 1, 0), // Ensure count does not go below 0
    }));
  };
  // console.log(itemCounts,'itemsCounts')
  const handleCountPlus = ({ itemId, serviceId, count }) => {
    console.log("itemId, serviceId,count", itemId, serviceId, count);
    const key = `${itemId}_${serviceId}`;
    setItemCounts((prevItemCounts) => ({
      ...prevItemCounts,
      [key]: (prevItemCounts[key] || Number(count)) + 1,
    }));
  };
  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (pagination.current < pagination.totalPages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };
  const handleScrollStore = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (paginationStore.current < pagination.totalPages) {
        setPaginationStore((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };

  // const handleApplyCoupon = async () => {
  //   try {
  //     const payload = {
  //       coupon_code: coupenCode,
  //       total_amount: totalPrice,
  //     };

  //     const response = await API_COUPEN_ORDER(payload);
  //     // setCoupenData(response?.discounted_amount);
  //     setCoupenData(response?.coupon);

  //     toast.success("Coupon applied successfully!");
  //     setCoupenVisible(false);
  //   } catch (error) {
  //     console.error("Error applying coupon:", error);
  //     toast.error(error?.response?.data?.error);
  //   }
  // };
  const handleApplyCoupon = async (price) => {
    try {
      const payload = {
        coupon_code: coupenCode,
        // total_amount: price,
        user_id: selectedUser?._id,
      };
      if (selectedUser) {
        const response = await API_COUPEN_ORDER(payload);
        // setCoupenData(response?.discounted_amount);
        setCoupenData(response?.coupon);
        setApplyCoupen(true);

        toast.success("Coupon applied successfully!");
      } else {
        setCoupenData(false);

        toast.error("Please select user first which you want to give coupen");
      }
      setCoupenVisible(false);
    } catch (error) {
      console.error("Error applying coupon:", error);
      toast.error(error?.response?.data?.error);
    }
  };
  const FetchDeliveryFee = async () => {
    try {
      const newData = await API_DELIVERY_ORDER({
        total_amount: totalPrice + deliveryFee,
      });
      setDeliveryFee(newData?.delivery_fee);
      setTax(newData?.tax_amount);

      console.log("delivery Fee", newData);
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  //   const fetchDataMainLaundry = async (page) => {
  //     try {
  //       setLoading(true);
  //       const params = {
  //         page: page,
  //         limit: pagination.pageSize,
  //         name: "",
  //       };
  //       const newData = await API_LIST_MAIN_LAUNDRY(params);
  //       setData((prevData) => [...prevData, ...newData.laundry]);
  //       setPagination((prevPagination) => ({
  //         ...prevPagination,
  //         totalPages: newData.totalPages,
  //       }));
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const fetchDataMainLaundry = async (page) => {
    try {
      setLoadingLaundry(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_MAIN_LAUNDRY(params);
      setData((prevData) => [...prevData, ...newData.laundry]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.totalPages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingLaundry(false);
    }
  };
  //   const fetchDataMainLaundry = async (page = 1, pageSize = 8) => {
  //     console.log("page ==>", page, pageSize);
  //     try {
  //       setLoadingLaundry(true);
  //       const params = {
  //         page,
  //         limit: pageSize,
  //       };
  //       const response = await API_LIST_MAIN_LAUNDRY(params);
  //       const { users, totalPages, totalUsers } = response; // Adjusting according to API response
  //       setData((prevUserList) => [...prevUserList, ...users]);
  //       setPagination((prevPagination) => ({
  //         ...prevPagination,
  //         current: page,
  //         total: totalUsers,
  //         totalPages: totalPages,
  //       }));
  //       setLoadingLaundry(false);
  //     } catch (error) {
  //       console.error("Error fetching users:", error);
  //       setLoadingLaundry(false);
  //     }
  //   };

  const fetchDataStore = async (page) => {
    try {
      setLoadingStore(true);
      const params = {
        page: page,
        limit: paginationStore.pageSize,
        laundry: mainLaundry,
      };
      const newData = await API_LIST_STORE(params);
      // setDataStore((prevData) => [...prevData, ...newData.providers]);
      setDataStore(newData?.providers);

      setPaginationStore((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingStore(false);
    }
  };
  const fetchDataOrder = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_ORDER(id);
      setEditData(newData?.order);
      const newDatas = [newData?.order?.main_laundry_info];
      const preSelectedOption = newDatas?.find(
        (option) => option?._id === newData?.order?.main_laundry
      );
      console.log("preSelectedOptionzzssssss", preSelectedOption);
      if (preSelectedOption) {
        console.log("preSelectedOption inside", preSelectedOption);
        setSelectedOptionUser(preSelectedOption);
        setMainLaundry(preSelectedOption);
      }
      setAllitemsList(newData?.order?.raw_items);
      if (newData?.order?.order_user_info?.address) {
        selectUser(newData?.order?.order_user_info);
      } else {
        selectUser({
          ...newData?.order?.order_user_info,
          address: newData?.order?.order_delivery_address
            ? [{ ...newData?.order?.order_delivery_address, is_selected: true }]
            : [], // add address array
        });
      }

      console.log(newData?.order, "fadjlfj8oh3lkjhuserinfo");
      setSelectedCustmerType(newData?.order?.order_user_info?.customer_type);
      setDeliveryTime(newData?.order?.order_delivery_time);
      // setPaymentMethod(newData?.order?.invoice_details?.payment_type);
      setPaymentMethod(newData?.order?.invoice_details?.payment_type);
      console.log(newData?.order?.payment_type, "paymentType");
      setSelectedPaymentStatus(newData?.order?.invoice_details?.payment_status);
      setCoupenCode(newData?.order?.coupon_details?.coupon_code);
      setCoupenData(newData?.order?.invoice_details?.discount);
      setDiscount(newData?.order?.invoice_details?.discount);
      const newDataStore = [newData?.order?.order_provider_before_service_info];
      const preSelectedOptionStore = newDataStore?.find(
        (option) =>
          option?._id === newData?.order?.order_provider_before_service
      );
      if (preSelectedOptionStore) {
        setSelectedOptionUserStore(preSelectedOptionStore);
        setStore(preSelectedOptionStore);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  console.log(selectedUser, "selectedUserhai");

  useEffect(() => {
    fetchDataOrder();
  }, [id]);
  useEffect(() => {
    fetchDataStore(pagination.current);
  }, [paginationStore.current, mainLaundry]);
  useEffect(() => {
    fetchDataMainLaundry(pagination.current);
  }, [pagination.current]);

  useEffect(() => {
    let itemsCount = 0;
    const total = alItemsList?.reduce((total, item) => {
      const itemTotal = calculateTotalPrice(item);

      const itemServices =
        item?.item_info?.item_service || item?.item_service || [];
      const serviceCount = itemServices.reduce((count, service) => {
        const key = `${item._id}_${service._id}`;
        return count + (itemCounts[key] || Number(service.quantity) || 0);
      }, 0);
      itemsCount += serviceCount;
      return total + itemTotal;
    }, 0);
    setTotalPrice(total);
    setTotalItems(itemsCount);
  }, [alItemsList, itemCounts]);

  // useEffect(() => {
  //   FetchDeliveryFee();
  // }, [totalPrice]);
  // laundry
  console.log("EditData", editData);

  // let discount = 0;

  // if (coupenData) {
  //   if (coupenData.coupon_type === "fixed") {
  //     discount = coupenData?.coupon_discount;
  //   } else if (coupenData?.coupon_type === "percentage") {
  //     // Apply percentage discount
  //     discount =
  //       (deliveryFee + tax + totalPrice) * (coupenData.coupon_discount / 100);
  //     console.log("discount insdie", discount);
  //   }
  // }
  useEffect(() => {
    // if (coupenData) {
    //   if (coupenData.coupon_type === "fixed") {
    //     setDiscount(coupenData?.coupon_discount);
    //   } else if (coupenData?.coupon_type === "percentage") {
    //     // Apply percentage discount
    //     let perce = (tax + totalPrice) * (coupenData.coupon_discount / 100);
    //     setDiscount(perce);

    //     console.log("discount insdie", discount);
    //   }
    // }
    if (coupenData) {
      if (coupenData) {
        if (coupenData.coupon_type === "fixed") {
          setDiscount(coupenData?.coupon_discount);
        } else if (coupenData?.coupon_type === "percentage") {
          // Apply percentage discount
          let totalAmount = Number(deliveryFee) + Number(totalPrice);
          let perce = (coupenData.coupon_discount / 100) * totalAmount;

          // discount = (coupenData?.coupon_discount / 100) * totalAmount;
          setDiscount(perce);
          console.log("discount insdie", discount);
          console.log("totalAmount", totalAmount);
        }
      }
      let total_calulated_price_withoutdilivery =
        deliveryFee + totalPrice - discount;

      let total_calulated_price = deliveryFee + tax + totalPrice - discount;
    }
  }, [coupenData]);

  let total_calulated_price = deliveryFee + tax + totalPrice - discount;

  const itemsPayload = alItemsList?.map((item) => {
    const itemServices =
      item?.item_info?.item_service || item?.item_service || [];
    const totalQuantity = itemServices?.reduce((total, service) => {
      return total + (Number(itemCounts[service._id]) || 0);
    }, 0);
    return {
      order_note: itemNotes[item?._id] || "", // Add the note here
      handle_note: itemNotes[item?._id] || "", // Add the note here
      category_id: catagory ? catagory : "669df06fa169e3684af8cdb1",
      item_service:
        itemServices?.map((service) => {
          const key = `${item._id}_${service._id}`;

          console.log("service ==>", service, key);
          return {
            item_service_id: service?.item_service,
            price: Number(service?.price || 0),
            quantity: itemCounts[key] || Number(service?.quantity), // Add the count here

            // quantity: Number(itemCounts[service?._id]) || 0, // Add the count here
          };
        }) || [],

      item_id: item?._id,
      total_quantity: totalQuantity,
      // total_quantity: itemCounts[item._id]?.toString() || "1",
      total_price: calculateTotalPrice(item),
    };
  });
  const createOrderPayload = () => {
    // const itemsPayload = alItemsList?.map((item) => {
    //   const itemServices =
    //     item?.item_info?.item_service || item?.item_service || [];
    //   const totalQuantity = itemServices?.reduce((total, service) => {
    //     return total + (Number(itemCounts[service._id]) || 0);
    //   }, 0);
    //   return {
    //     order_note: itemNotes[item?._id] || "", // Add the note here
    //     handle_note: itemNotes[item?._id] || "", // Add the note here
    //     category_id: catagory ? catagory : "669df06fa169e3684af8cdb1",
    //     item_service:
    //       itemServices?.map((service) => {
    //         const key = `${item._id}_${service._id}`;

    //         console.log("service ==>", service, key);
    //         return {
    //           item_service_id: service?.item_service,
    //           price: Number(service?.price || 0),
    //           quantity: itemCounts[key] || Number(service?.quantity), // Add the count here

    //           // quantity: Number(itemCounts[service?._id]) || 0, // Add the count here
    //         };
    //       }) || [],

    //     item_id: item?._id,
    //     total_quantity: totalQuantity,
    //     // total_quantity: itemCounts[item._id]?.toString() || "1",
    //     total_price: calculateTotalPrice(item),
    //   };
    // });

    // const payload = {
    //   total_items: totalItems,
    //   delivery_fee: alItemsList?.length > 0 ? deliveryFee : 0,
    //   tax: tax,
    //   order_note: orderNote,

    //   discounted_amount: discount || 0,
    //   sub_total: totalPrice,
    //   // total: totalPrice + deliveryFee + tax - (coupenData || 0),
    //   total: total_calulated_price,
    //   currency: "SAR", // Adjust based on your currency logic
    //   is_discounted_order: !!coupenData,
    //   order_type: selectedOrderType, // Adjust based on your order type logic
    //   order_scheme: "normal", // Adjust based on your order scheme logic

    //   customer_type: selectedCustmerType,
    //   items: itemsPayload,
    //   order_pickup_time: {
    //     from: pickUpTime?.from ? pickUpTime?.from : moment(new Date()).unix(),
    //     to: pickUpTime?.to ? pickUpTime?.to : moment(new Date()).unix(),
    //   },
    //   order_delivery_time: {
    //     from: deliveryTime?.from,
    //     to: deliveryTime?.to,
    //   },
    //   order_pickup_address: {
    //     first_name: selectedUser?.first_name || "",
    //     location: selectedUser?.address?.[0]?.location || "",
    //     last_name: selectedUser?.last_name || "",
    //     phone_no: selectedUser?.phone_no || "",
    //     building: selectedUser?.address?.[0]?.building || "",
    //     apartment: selectedUser?.address?.[0]?.apartment || "",
    //     floor: selectedUser?.address?.[0]?.floor || "",
    //     street: selectedUser?.address?.[0]?.street || "",
    //     additional_directions:
    //       selectedUser?.address?.[0]?.additional_directions || "",
    //     geo: {
    //       coordinates: [
    //         selectedUser?.geo?.coordinates?.[0],
    //         selectedUser?.geo?.coordinates?.[1],
    //       ],
    //     },
    //   },
    //   order_delivery_address: {
    //     first_name: selectedUser?.first_name || "",
    //     location: selectedUser?.address?.[0]?.location || "",
    //     last_name: selectedUser?.last_name || "",
    //     phone_no: selectedUser?.phone_no || "",
    //     building: selectedUser?.address?.[0]?.building || "",
    //     apartment: selectedUser?.address?.[0]?.apartment || "",
    //     floor: selectedUser?.address?.[0]?.floor || "",
    //     street: selectedUser?.address?.[0]?.street || "",
    //     additional_directions:
    //       selectedUser?.address?.[0]?.additional_directions || "",
    //     geo: {
    //       coordinates: [
    //         selectedUser?.geo?.coordinates?.[0],
    //         selectedUser?.geo?.coordinates?.[1],
    //       ],
    //     },
    //   },
    //   payment_type: paymentMethod,
    //   payment_status: selectedPaymentStatus,
    //   order_category: catagory ? catagory : "669df06fa169e3684af8cdb1",
    //   main_laundry: "66a36f36a8b7d2b43551a939",
    //   order_provider_before_service:
    //     typeof store === "object" ? store?._id : store,
    //   order_user: selectedUser?._id,
    // };
    const selectedAddress = selectedUser?.address?.find((item) => item?.is_selected);

    const payload = {
      total_items: totalItems,
      delivery_fee: paymentInfo?.deliveryFee ? paymentInfo?.deliveryFee : 0,
      tax: paymentInfo?.taxAmount ? paymentInfo?.taxAmount : 0,
      order_note: orderNote,
      coupon_details: coupenCode ? { coupon_code: coupenCode } : null,

      discounted_amount: paymentInfo?.discount ? paymentInfo?.discount : 0,
      sub_total: paymentInfo?.subtotal,
      // total: totalPrice + deliveryFee + tax - (coupenData || 0),
      total: paymentInfo?.totalAmount,
      currency: "SAR", // Adjust based on your currency logic
      is_discounted_order: !!coupenData,
      order_type: selectedOrderType,
      order_scheme: "normal",
      customer_type: selectedCustmerType,
      items: itemsPayload,
      order_pickup_time: {
        from: pickUpTime?.from ? pickUpTime?.from : moment(new Date()).unix(),
        to: pickUpTime?.to ? pickUpTime?.to : moment(new Date()).unix(),
      },
      order_delivery_time: {
        from: deliveryTime?.from,
        to: deliveryTime?.to,
      },
      order_pickup_address: {
        first_name: selectedUser?.first_name || "",
        location: selectedUser?.address?.[0]?.location || "",
        last_name: selectedUser?.last_name || "",
        phone_no: selectedUser?.phone_no || "",
        building: selectedUser?.address?.[0]?.building || "",
        apartment: selectedUser?.address?.[0]?.apartment || "",
        floor: selectedUser?.address?.[0]?.floor || "",
        street: selectedUser?.address?.[0]?.street || "",
        additional_directions:
          selectedUser?.address?.[0]?.additional_directions || "",
        geo: {
          coordinates: selectedAddress ? selectedAddress?.geo?.coordinates :  EditData?.order_pickup_address?.geo?.coordinates,

          // coordinates: [
          //   selectedUser?.geo?.coordinates?.[0],
          //   selectedUser?.geo?.coordinates?.[1],
          // ],
        },
      },
      order_delivery_address: {
        first_name: selectedUser?.first_name || "",
        location: selectedUser?.address?.[0]?.location || "",
        last_name: selectedUser?.last_name || "",
        phone_no: selectedUser?.phone_no || "",
        building: selectedUser?.address?.[0]?.building || "",
        apartment: selectedUser?.address?.[0]?.apartment || "",
        floor: selectedUser?.address?.[0]?.floor || "",
        street: selectedUser?.address?.[0]?.street || "",
        additional_directions:
          selectedUser?.address?.[0]?.additional_directions || "",
        geo: {
          coordinates: selectedAddress ? selectedAddress?.geo?.coordinates :  EditData?.order_delivery_address?.geo?.coordinates,

          // coordinates: [
          //   selectedUser?.geo?.coordinates?.[0] || EditData?.geo?.coordinates?.[0],
          //   selectedUser?.geo?.coordinates?.[1]|| EditData?.geo?.coordinates?.[0],
          // ],
        },
      },
      payment_type: paymentMethod,
      payment_status: selectedPaymentStatus,
      order_category: catagory ? catagory : "669df06fa169e3684af8cdb1",
      main_laundry: "66a36f36a8b7d2b43551a939",
      order_provider_before_service:
        typeof store === "object" ? store?._id : store,
      order_user: selectedUser?._id,
    };

    return payload;
  };
  console.log("EditDatadsadsad",EditData,selectedUser)
  const UpdateOrder = async () => {
    if (!selectedUser) {
      toast.error("please Add user first");
    } else if (!deliveryTime) {
      toast.error("please select Delivery Time");
    } else {
      setLoadingOrder(true);

      try {
        const payload = createOrderPayload();
        var responseOrder = await API_UPDATE_ORDER(payload, id);
        toast.success("Order Updated successfully!");
        setOrderId(responseOrder?.order?._id);
        setLoadingOrder(false);
        if (
          paymentMethod === "credit_card" ||
          (paymentMethod === "cash_on_delivery" &&
            selectedOrderType === "express")
        ) {
          if (responseOrder) {
            try {
              const payloads = {
                metaData: {
                  paymentType:
                    selectedOrderType === "express" &&
                    paymentMethod === "cash_on_delivery"
                      ? "partial_deposit"
                      : "order",
                  order_id: responseOrder?.order?._id,
                },
              };
              const response = await API_PAYMENT_ORDER(payloads);
              const redirectURL = response?.redirectURL;
              console.log("response payment", response);
              if (redirectURL) {
                window.open(redirectURL, "_blank");
              }
              console.log("Order created successfully:", response);
            } catch (error) {
              toast.error(
                error?.response?.data?.exception ?? "Something went Wrong"
              );
              console.error("Error creating order:", error);
            }
          }
        }
        Navigate(`/admin/order-management/${responseOrder?.order?._id}`);
      } catch (error) {
        toast.error(
          error?.responseOrder?.data?.exception ?? "Something went Wrong"
        );
        setLoadingOrder(false);
      }
    }
  };

  console.log("total_calulated_price", total_calulated_price);

  console.log("mainLaundry , store", mainLaundry, store);

  const calculateAmount = async () => {
    try {
      const payload = {
        items: itemsPayload,
        coupon_details: coupenData ? { coupon_code: coupenCode } : null,
        is_discounted_order: applyCoupen ? true : false,
        order_id: id,
      };

      const apiResponse = await API_CALCULATE_AMOUNT(payload);

      console.log("calucalte", apiResponse);

      if (apiResponse) {
        setPaymentInfo({
          amountDue: apiResponse?.data?.amountDue || 0,
          amountPaid: apiResponse?.data?.amountPaid || 0,
          deliveryFee: apiResponse?.data?.deliveryFee || 0,
          discount: apiResponse?.data?.discount || 0,
          subtotal: apiResponse?.data?.subtotal || 0,
          taxAmount: apiResponse?.data?.taxAmount || 0,
          totalAmount: apiResponse?.data?.totalAmount || 0,
        });
      }
    } catch (error) {
      console.error("error", error);
      // toast.error(error?.response?.data?.message);
    } finally {
      // setSubmitting(false);
    }
  };
  useEffect(() => {
    calculateAmount();
  }, [totalItems, id, alItemsList, itemCounts, coupenCode, applyCoupen]);
  useEffect(() => {
    console.log("deliveryTimes", deliveryTimes);
    setPickUpTime(deliveryTimes);
  }, [slotVisibleDelvery, editData]);

  console.log("payment info", paymentInfo);

  return (
    <>
      <div className=" ">
        <div className="mb-4">
          <div className="mb-4">
            <Row gutter={[16, 16]}>
              {/* <Col span={12}>
                <div className="relative">
                  <label
                    for="floating_outlined"
                    className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-[17px] text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                    style={{ fontSize: "17px" }}
                  >
                    Select Laundry
                  </label> */}
              {/* <Select
                    className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
     
                    showSearch
                    placeholder="Select Laundry"
                    optionFilterProp="children"
                    onPopupScroll={handleScroll}
                    filterOption={(input, option) =>
                      option?.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    loading={loading}
                    onChange={(value) => {
                      console.log("value", value);
                      setMainLaundry(value);
              
                    }}
                  >
                    {data?.map((item) => (
                      <Option key={item._id} value={item._id}>
                        {item.laundry_name}
                      </Option>
                    ))}
                  </Select> */}

              {/* <Select
                    className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                    showSearch
                    placeholder="Select Laundry"
                    optionFilterProp="children"
                    onPopupScroll={handleScroll}
                    // value={selectedOption}
                    value={
                      selectedOptionUser
                        ? selectedOptionUser?.laundry_name
                        : undefined
                    }
                    filterOption={(input, option) =>
                      option?.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    loading={loading}
                    onChange={(value) => {
                      const selected = data?.find((item) => item._id === value);
                      console.log("selected ==>", selected);
                      setSelectedOptionUser(selected);
                      setMainLaundry(value);
                      // setFieldValue("laundry", value);
                      // setTouched({ laundry: true });
                    }}
                  >
                    {data?.map((item) => (
                      <Option key={item._id} value={item._id}>
                        {item.laundry_name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col> */}
              <Col span={12}>
                {process.env.REACT_APP_APPLICATION_NAME === "admin" ? (
                  <div className="relative">
                    <label
                      for="floating_outlined"
                      className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-[17px] text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      style={{ fontSize: "17px" }}
                    >
                      {t("Select Store")}
                    </label>
                    <Select
                      value={
                        selectedOptionUserStore
                          ? selectedOptionUserStore?.store_name
                          : undefined
                      }
                      className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      // {...field}
                      // value={store}
                      showSearch
                      placeholder={t("Select Store")}
                      optionFilterProp="children"
                      onPopupScroll={handleScrollStore}
                      filterOption={(input, option) =>
                        option?.children
                          .toLowerCase()
                          .indexOf(input?.toLowerCase()) >= 0
                      }
                      loading={loadingStore}
                      onChange={(value) => {
                        console.log("value", value);
                        //
                        const selected = dataStore?.find(
                          (item) => item._id === value
                        );
                        console.log("selected ==>", selected);
                        setSelectedOptionUserStore(selected);
                        setStore(value);
                        // setFieldValue("laundry", value);
                        // setTouched({ laundry: true });
                      }}
                    >
                      {dataStore?.map((item) => (
                        <Option key={item._id} value={item?._id}>
                          {item?.store_name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </div>
          <div className="flex items-center justify-between gap-8 text-xl font-semibold">
            <div className="flex items-center space-x-4 ">
              <span className="">
                {selectedUser ? (
                  <img
                    src={
                      selectedUser?.profile_image?.[0]?.file_url
                        ? CONSTANTS?.IMG_DIRECTORY +
                          selectedUser?.profile_image?.[0]?.file_url
                        : userplace
                    }
                    style={{
                      height: "5rem",
                      width: "5rem",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                    alt=""
                  />
                ) : (
                  <img src={LocationIcon} alt="" />
                )}
              </span>{" "}
              <div>
                {console.log(selectedUser, "inDeldfshaljkfhlzueyrl")}
                <span className="font-poppins text-[15px] font-medium text-[#3860A4]">
                  {selectedUser
                    ? selectedUser?.first_name + " " + selectedUser?.last_name
                    : t("No user Info")}
                </span>
                <div className="font-poppins text-[12px] font-medium text-[#9496AE]">
                  {selectedUser?.address?.map((element) => {
                    const check = element?.is_selected;
                    return <div>{check ? element?.location : null} </div>;
                  })}
                  {/* No.45 - al Riyadh Province 123334, building */}
                </div>
              </div>
            </div>
            {selectedUser && (
              <div onClick={() => setModalVisibleUser(true)}>
                <img src={EditIcon} />
              </div>
            )}
            {!selectedUser && (
              <Button
                className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 text-[white]"
                onClick={() => setModalVisibleUser(true)}
              >
                {t("Add New Customer")}
              </Button>
            )}
          </div>

          <div className="mb-6 ml-4 mt-6 flex justify-between space-x-4">
            <div>
              <h3 className="text[12.9px] mb-1 font-[inter] text-lg font-normal text-[#232323]">
                {t("Customer Type")}
              </h3>
              <div className="mr-3 flex gap-[0.3rem]">
                <div className="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="cursor-pointer"
                      style={{
                        border:
                          selectedCustmerType === "walking"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedCustmerType === "walking"}
                      onChange={() => handleCheckboxChange("walking")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedCustmerType === "walking"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      {t("Walking")}
                    </span>
                  </div>
                </div>

                <div class="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="ml-1 cursor-pointer"
                      style={{
                        border:
                          selectedCustmerType === "call"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedCustmerType === "call"}
                      onChange={() => handleCheckboxChange("call")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedCustmerType === "call"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      {t("Call")}
                    </span>
                  </div>
                </div>

                <div class="checkbox-wrapper-40 mr-1">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="ml-1 cursor-pointer"
                      style={{
                        border:
                          selectedCustmerType === "app"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedCustmerType === "app"}
                      onChange={() => handleCheckboxChange("app")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedCustmerType === "app"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      {t("App")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="flex flex-col items-center gap-4 2xl:flex-row ">
              <div
                className="relative h-auto cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-[12px]"
                style={{
                  border: "1px solid #CEAF89",
                  // paddingBottom: "8px",
                  // paddingTop: "8px",
                }}
                onClick={() => {
                  if (selectedCustmerType === "call") {
                    handleConfirm();
                    setSlotVisible(true);
                  }
                }}
              >
                <div className="absolute left-[6px] top-[-6px] rounded-[3.13px] bg-[#FAF7F3] px-1 text-[9px] text-[#F4B718]">
                  Collection Time & Date
                </div>
                <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                  <img src={collectionDate} className="h-4" />
                </div>

                <p className="text-center">
                  {" "}
                  {selectedCustmerType === "call"
                    ? pickUpTime?.from
                      ? moment.unix(pickUpTime?.from).format("h A") +
                        " - " +
                        moment
                          .unix(pickUpTime?.to)
                          .format("h A ddd, MMM D, YYYY")
                      : "Select Pickup Time"
                    : moment().format("h A ddd, MMM D, YYYY")}
                </p>
              </div>

              <div
                className="relative h-auto cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px]  text-[12px]"
                style={{
                  border: "1px solid #1CAB43",
                  // paddingBottom: "8px",
                  // paddingTop: "8px",
                }}
                onClick={() => {
                  handleConfirm();
                  setSlotVisibleDelvery(true);
                }}
              >
                <div className="absolute left-[6px] top-[-6px]">
                  <img src={deliverytimes} />
                </div>
                <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                  <img src={editdeleivery} className="h-4" />
                </div>
                <p className="text-center">
                  {" "}
                  {deliveryTime
                    ? moment.unix(deliveryTime.from).format("h A") +
                      " - " +
                      moment
                        .unix(deliveryTime.to)
                        .format("h A ddd, MMM D, YYYY")
                    : "Select Delivery Time"}
                </p>
              </div>
            </div> */}

            <div className="flex items-center gap-4 ">
              <div
                className="relative h-auto cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px] text-[12px]"
                style={{
                  border: "1px solid #CEAF89",
                  // paddingBottom: "8px",
                  // paddingTop: "8px",
                }}
                onClick={() => {
                  if (selectedCustmerType === "call") {
                    handleConfirm();
                    setSlotVisible(true);
                  }
                }}
              >
                <div className="absolute left-[6px] top-[-6px] rounded-[3.13px] bg-[#FAF7F3] px-1 text-[9px] text-[#F4B718]">
                  {/* <img src={editCollection} /> */}
                  {t("Pickup Time & Date")}
                </div>
                <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                  <img src={collectionDate} className="h-4" />
                </div>

                {selectedCustmerType === "call"
                  ? pickUpTime?.from
                    ? moment.unix(pickUpTime?.from).format("h A") +
                      " - " +
                      moment.unix(pickUpTime?.to).format("h A ddd, MMM D, YYYY")
                    : "Select Pickup Time"
                  : moment().format("h A ddd, MMM D, YYYY")}
              </div>

              <div
                className="relative h-auto cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px]   text-[12px]"
                style={{
                  border: "1px solid #1CAB43",
                  // paddingBottom: "8px",
                  // paddingTop: "8px",
                }}
                onClick={() => {
                  handleConfirm();
                  setSlotVisibleDelvery(true);
                }}
              >
                <div className="absolute left-[6px] top-[-6px]">
                  <img src={deliverytimes} />
                </div>
                <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                  <img src={editdeleivery} className="h-4" />
                </div>
                {/* 9Am -11Am Tue, 2024 */}
                {deliveryTime
                  ? moment.unix(deliveryTime.from).format("h A") +
                    " - " +
                    moment.unix(deliveryTime.to).format("h A ddd, MMM D, YYYY")
                  : t("Select Delivery Time")}
              </div>
            </div>
          </div>
          <hr />
        </div>

        <div className="scroll- mb-4 max-h-96 min-h-96 overflow-x-hidden overflow-y-scroll">
          <h2 className="mb-4 font-[inter] text-lg font-semibold text-[#232323]">
            {t("Selected Items")}
          </h2>

          <div className="">
            {alItemsList?.length > 0
              ? alItemsList?.map((item) => {
                  const totalCount = calculateTotalQuantity(item);
                  const totalPrice = calculateTotalPrice(item);
                  console.log("totalPrice ==>", totalPrice);
                  return (
                    <>
                      {totalCount > 0 ? (
                        <div className="relative" key={item._id}>
                          <Card
                            className="side-card relative mb-3 cursor-pointer rounded-lg border shadow-sm"
                            onClick={() => {
                              handleCardClick(item);
                            }}
                          >
                            <div className="flex items-center justify-between pb-0 pt-0 ">
                              <div className="flex w-1/2 gap-2">
                                <div>
                                  <img
                                    src={
                                      CONSTANTS?.IMG_DIRECTORY +
                                      item?.images?.[0]?.file_url
                                    }
                                    alt="Thobe Summer"
                                    className="h-12 w-12 rounded-[50%]"
                                  />
                                </div>

                                <div>
                                  <h3 className="font-poppins font-semibold text-[#3860A4]">
                                    {item?.name}
                                  </h3>
                                </div>
                              </div>

                              <div className="grid w-1/2 grid-cols-2 gap-2">
                                {item?.item_service?.map((element, idx) => {
                                  const isCheck =
                                    element?.item_service ===
                                      item?.item_info?.item_service[idx]?._id &&
                                    item?.item_info?.item_service[idx]
                                      ?.quantity > 0;

                                  const service = item.item_service[0];
                                  const key = `${item._id}_${item.item_service[idx]?._id}`;
                                  console.log(key, "itemCounts");
                                  const isCheckAgain = itemCounts[key] > 0;
                                  return (
                                    <Fragment key={idx}>
                                      {isCheck || isCheckAgain ? (
                                        <p className="text-sm text-gray-500">
                                          {element?.service_info?.name}
                                        </p>
                                      ) : null}
                                    </Fragment>
                                  );
                                })}
                              </div>

                              <div className="w-1/4">
                                <p className=" font-poppins font-semibold text-[#3860A4]">
                                  {t("SAR")} {totalPrice}
                                </p>
                              </div>

                              <div
                                className="flex w-[28%] space-x-4 bg-[#172e5512]"
                                style={{
                                  padding: "4px 6px",
                                  borderRadius: "100px",
                                }}
                              >
                                <img
                                  src={minusIcon}
                                  className="w-[1.2rem] cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const service = item.item_service[0];
                                    handleCountMinus({
                                      itemId: item._id,
                                      serviceId: service._id,
                                    });
                                  }}
                                  alt=""
                                />
                                <p className="text-600 text-[#3860A4]">
                                  {totalCount}
                                </p>
                                <img
                                  src={plusIcon}
                                  className="w-[1.2rem] cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const service = item.item_service[0];
                                    handleCountPlus({
                                      itemId: item._id,
                                      serviceId: service._id,
                                    });
                                  }}
                                  alt=""
                                />
                                <div
                                  className="absolute "
                                  style={{
                                    right: "0px",
                                    bottom: "0px",
                                    top: "-19px",
                                    left: "-21px",
                                  }}
                                >
                                  <Button
                                    type="text"
                                    icon={
                                      <TiDelete
                                        style={{ fontSize: "1.5rem" }}
                                      />
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent the card click event
                                      setItemToDelete(item);
                                      setIsDeleteModalVisible(true);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </Card>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </>
                  );
                })
              : "No Selected Item"}
          </div>
        </div>
        <Modal
          visible={isDeleteModalVisible}
          onCancel={() => setIsDeleteModalVisible(false)}
          centered
        >
          <div className="mt-7 flex w-full flex-col items-center justify-center gap-2">
            <h1 className="w-[300px] text-center font-poppins text-[18px] font-medium leading-[28px]">
              {t("Are you sure you want to delete this item?")}
            </h1>
            <div className="flex flex-row items-center gap-2">
              <Button
                className=" text-black flex  w-40 p-5"
                onClick={() => setIsDeleteModalVisible(false)}
              >
                {t("Cancel")}
              </Button>
              <Button
                className="btn-gradient   flex w-40  p-5 text-[white]"
                onClick={() => handleRemoveClick(itemToDelete)}
              >
                {t("Confirm")}
              </Button>
            </div>
          </div>
        </Modal>

        <div className="mb-4">
          <hr className="mb-4" />
          <div className="flex items-baseline justify-between gap-1">
            <div className="flex items-baseline ">
              <h2 className="text-lg font-medium ">{t("Order Summary :")}</h2>
              <span className="mb-4 font-poppins font-semibold  text-[#46BCED]">
                &nbsp;
                {coupenData ? coupenCode : t("No Coupen Availble")}
              </span>
            </div>
            <p
              className="cursor-pointer text-[15px] font-medium text-[#4732F4]"
              style={{ borderBottom: "1px solid" }}
              onClick={() => {
                setCoupenVisible(true);
              }}
            >
              {t("Add Coupon")}
            </p>
          </div>
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Service Category")}
            </span>

            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {t("Normal")}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Total Items")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {totalItems} {t("Items")}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Service Charges")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {/* {Number(totalPrice).toFixed(2) ?? 0} SAR */}
              {paymentInfo?.subtotal?.toFixed(2)} {t("SAR")}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Tax")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {/* {Number(tax).toFixed(2)} SAR */}
              {paymentInfo?.taxAmount?.toFixed(2)} {t("SAR")}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Delivery Fees")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
              {/* {alItemsList?.length > 0 ? Number(deliveryFee).toFixed(2) : 0} SAR */}
              {paymentInfo?.deliveryFee?.toFixed(2)} {t("SAR")}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Total Amount")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#79b3ec]">
              {paymentInfo?.totalAmount?.toFixed(2)} {t("SAR")}
            </span>
          </div>
          {/* {editData?.invoice_details?.payment_status === "paid" && (
            <div className="flex justify-between">
              <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                Total Amount
              </span>
              <span className="font-poppins text-[15px] font-semibold text-[#79b3ec]">
                {alItemsList?.length > 0
                  ? editData?.invoice_details?.payment_status === "paid"
                    ? // editData?.invoice_details?.amount_paid +
                      Number(totalPrice + deliveryFee + tax).toFixed(2)
                    : Number(totalPrice + deliveryFee + tax).toFixed(2)
                  : 0}
                SAR
              </span>
            </div>
          )} */}
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Discounted Amount")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#ff0000]">
              {paymentInfo?.discount?.toFixed(2)} {t("SAR")}
            </span>
          </div>
          {/* <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {editData?.invoice_details?.payment_status === "paid"
                ? " Discounted Amount"
                : "Total"}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#ff0000]">
              {alItemsList?.length > 0
                ? editData?.invoice_details?.payment_status === "paid"
                  ? (editData?.invoice_details?.amount_due) // editData?.invoice_details?.amount_paid // tax - // deliveryFee + // totalPrice +
                      .toFixed(2)
                  : Number(totalPrice + deliveryFee + tax).toFixed(2)
                : 0}
              SAR
            </span>
          </div> */}
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Total Paid Amount")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[green]">
              {paymentInfo?.amountPaid?.toFixed(2)} {t("SAR")}
            </span>
          </div>

          {/* {editData?.invoice_details?.amount_paid ? (
            <div className="flex justify-between">
              <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                Total Paid Amount
              </span>
              <span className="font-poppins text-[15px] font-semibold text-[green]">
                {editData?.invoice_details?.amount_paid
                  ? Number(editData?.invoice_details?.amount_paid).toFixed(2)
                  : 0}
                SAR
              </span>
            </div>
          ) : (
            ""
          )} */}
          <div className="flex justify-between">
            <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
              {t("Total Pending Amount")}
            </span>
            <span className="font-poppins text-[15px] font-semibold text-[#800075]">
              {paymentInfo?.amountDue?.toFixed(2)} {t("SAR")}
            </span>
          </div>

          {/* {editData?.invoice_details?.amount_due ? (
            <div className="flex justify-between">
              <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                Total Pending Amount
              </span>
              <span className="font-poppins text-[15px] font-semibold text-[#800075]">
                {editData?.invoice_details?.amount_due
                  ? Number(editData?.invoice_details?.amount_due).toFixed(2)
                  : 0}
                SAR
              </span>
            </div>
          ) : (
            ""
          )} */}

          {/* {coupenData && alItemsList?.length > 0 ? (
            <div className="flex items-center justify-between">
              <span className="mt-4 font-poppins text-[#9496AE]">
                Total After Discount
              </span>
              <span className="mt-4 font-poppins text-xl font-semibold text-red-500">
                {Number(total_calulated_price).toFixed(2)} SAR
              </span>
            </div>
          ) : (
            ""
          )} */}
        </div>
        <hr className="mb-4 mt-4" />
        <div className="mb-4">
          <div className="flex justify-between">
            <h2 className="text-lg font-medium">{t("Payment")}</h2>
            <p
              className="cursor-pointer text-[15px] font-medium text-[#4732F4]"
              style={{ borderBottom: "1px solid" }}
              onClick={() => {
                setPaymentVisible(true);
              }}
            >
              {t("Add Payment Method")} 
            </p>
          </div>
        </div>
        <hr className="mb-4 mt-4" />
        <div className="relative mb-3">
          <label
            for="floating_outlined"
            className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
          >
            {t("Add Note")}
          </label>
          <input
            className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
            type="text"
            name="order_note"
            placeholder={t("order Note")}
            onChange={(event) => setOrderNote(event.target.value)}
            // maxLength={20}
            // onKeyPress={(event) => {
            //   const charCode = event.charCode;
            //   if (
            //     !(charCode >= 65 && charCode <= 90) && // A-Z
            //     !(charCode >= 97 && charCode <= 122) && // a-z
            //     charCode !== 32 // space
            //   ) {
            //     event.preventDefault();
            //   }
            // }}
            // autoComplete="off"
          />
        </div>

        <hr className="mb-4 mt-4" />
        <Button
          className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 text-[white]"
          onClick={UpdateOrder}
        >
          {loadingorder ? t("Updating...") : t("Update Order")}
        </Button>
      </div>

      <Modal
        // title="Item Details"
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
        }}
      >
        {" "}
        <DetailModalCardEdit
          itemCounts={itemCounts}
          handleCountMinus={handleCountMinus}
          handleCountPlus={handleCountPlus}
          selectedItem={selectedItem}
          totalPrice={totalPrice}
          setTotalPrice={setTotalPrice}
          itemNotes={itemNotes}
          updateNote={updateNote}
          // itemCounts={itemCounts}
          // handleCountMinus={handleCountMinus}
          // handleCountPlus={handleCountPlus}
          // selectedItem={selectedItem}
        />
      </Modal>

      <Modal
        visible={slotVisible}
        onCancel={() => setSlotVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <CalendarSlot onConfirm={handleConfirm} />
        </div>
      </Modal>
      {console.log("dfsdfdfhsdiof", selectedOrderType)}
      {console.log(pickUpTime, "CalendarSlotDeliverysssssssssssss")}

      <Modal
        visible={slotVisibleDelvery}
        onCancel={() => setSlotVisibleDelvery(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          {/* <CalendarSlot onConfirm={handleConfirm} /> */}
          {pickUpTime?.from !== undefined && (
            <CalendarSlotDelivery
              onConfirm={handleConfirm}
              selectedOrderType={selectedOrderType}
              pickUpTime={pickUpTime}
              setPickUpTime={setPickUpTime}
              setSelectedOrderType={setSelectedOrderType}
            />
          )}
        </div>
      </Modal>

      <Modal
        visible={paymentVisible}
        onCancel={() => setPaymentVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <div className=" rounded-md bg-white p-4 shadow-md">
            <h2 className="mb-4 font-poppins text-xl font-semibold text-[#3860A4]">
              Payment
            </h2>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <div className="mb-4">
                <label className="mb-3 mt-3 block font-poppins font-medium text-[#3860A4]">
                  Select Payment Method
                </label>
                <div className="flex justify-between">
                  <label
                    className={`mr-2 flex flex-1 cursor-pointer items-center justify-between rounded-md border p-2 shadow-md
                 ${
                   paymentMethod === "cash_on_delivery"
                     ? "bosrder-[#46BCEsssssD]sasa"
                     : "bordser-grassssy-300"
                 }`}
                  >
                    <div>
                      <span>
                        <img
                          src={cashondelivery}
                          alt="Cash On Delivery"
                          className="h-6 w-6"
                        />
                      </span>
                      <span className="font-poppins font-medium text-[#3860A4]">
                        Cash On Delivery
                      </span>
                    </div>
                    <div>
                      <input
                        type="radio"
                        checked={
                          paymentMethod === "cash_on_delivery" ||
                          paymentMethod === "cod"
                        }
                        name="paymentMethod"
                        value="cash_on_delivery"
                        onChange={handleRadioChange}
                      />
                    </div>
                  </label>
                  <label
                    className={`mr-2 flex flex-1 cursor-pointer items-center justify-between rounded-md border p-2 shadow-md ${
                      paymentMethod === "credit_card"
                        ? "bordedsdr-[#46BCED]"
                        : "bordsder-gray-300"
                    }`}
                  >
                    <div>
                      <span>
                        <img
                          src={creditCard}
                          alt="Credit Card"
                          className="h-6 w-6"
                        />
                      </span>
                      <span className="font-poppins font-medium text-[#3860A4]">
                        Credit Card
                      </span>
                    </div>

                    <input
                      type="radio"
                      name="paymentMethod"
                      checked={paymentMethod === "credit_card"}
                      value="credit_card"
                      onChange={handleRadioChange}
                    />
                  </label>
                  <label
                    className={`flex flex-1 cursor-pointer  items-center justify-between rounded-md border p-2 shadow-md ${
                      paymentMethod === "hand_cash"
                        ? "borddser-[#46BCED]"
                        : "borddsder-gray-300"
                    }`}
                  >
                    <div>
                      <span>
                        <img
                          src={handonCash}
                          alt="Hand Cash"
                          className="h-6 w-6"
                        />
                      </span>
                      <span className="font-poppins font-medium text-[#3860A4]">
                        Hand Cash
                      </span>
                    </div>
                    <input
                      type="radio"
                      checked={paymentMethod === "hand_cash"}
                      name="paymentMethod"
                      value="hand_cash"
                      onChange={handleRadioChange}
                    />
                  </label>
                </div>
              </div>
            </div>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <div className="flex items-center justify-between">
                <span className="mt-4 font-poppins text-[#9496AE]">Total</span>
                <span className="mt-4 font-poppins text-xl font-semibold text-red-500">
                  {/* {alItemsList?.length > 0
                    ? coupenData
                      ? Number(total_calulated_price).toFixed(2)
                      : Number(totalPrice + deliveryFee + tax).toFixed(2)
                    : 0}{" "}
                  SAR */}
                  {/* {totalPrice + deliveryFee + tax} SAR */}
                  {/* {editData?.invoice_details?.payment_status === "paid"
                    ? paymentInfo?.amountDue.toFixed(2)
                    : paymentInfo?.totalAmount} */}
                  {Number(paymentInfo?.amountDue).toFixed(2)}
                  SAR
                </span>
              </div>
            </div>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4 mt-4 flex items-center gap-5">
              <label className=" block font-poppins text-[#3860A4]">
                Payment Status:
              </label>
              <div className="mr-3 flex gap-[0.3rem]">
                <div className="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="cursor-pointer"
                      style={{
                        border:
                          selectedPaymentStatus === "unpaid"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedPaymentStatus === "unpaid"}
                      onChange={() => handleCheckboxChangeStatus("unpaid")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedPaymentStatus === "unpaid"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      Unpaid
                    </span>
                  </div>
                </div>

                <div class="checkbox-wrapper-40">
                  <div className="flex gap-1">
                    <input
                      type="checkbox"
                      className="ml-1 cursor-pointer"
                      style={{
                        border:
                          selectedPaymentStatus === "paid"
                            ? "1px solid #46BCED"
                            : "1px solid #ccc",
                        height: "18px",
                        width: "18px",
                      }}
                      checked={selectedPaymentStatus === "paid"}
                      onChange={() => handleCheckboxChangeStatus("paid")}
                    />
                    <span
                      className={`checkbox text-[12px] ${
                        selectedPaymentStatus === "paid"
                          ? "text-[#3860A4]"
                          : "#8B8B8B"
                      }`}
                    >
                      Paid
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr className="text-[#C5C5C5]" />

            <Button
              className="btn-gradient  mx-auto ml-auto mt-3 flex w-48 items-center justify-center rounded-xl p-5 text-[white]"
              onClick={() => {
                setPaymentVisible(false);
              }}
            >
              Confirm Payment
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        visible={coupenVisible}
        onCancel={() => setCoupenVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <div className=" rounded-lg bg-white p-4 shadow-md">
            <h2 className="mb-4 font-poppins text-xl font-semibold text-[#3860A4]">
              Add coupon
            </h2>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <p className="mb-4 mt-4 font-poppins font-normal text-[#9496AE]">
                Enter your coupon code
              </p>
              <div className="relative">
                <label
                  for="floating_outlined"
                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                >
                  Add coupon Code
                </label>
                <div className="flex items-center gap-1">
                  <input
                    className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                    value={coupenCode}
                    onChange={(event) => {
                      setCoupenCode(event.target.value);
                    }}
                  />
                  <Button
                    className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 py-6 text-[white]"
                    onClick={() => handleApplyCoupon()}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        visible={modalVisibleUser}
        onCancel={() => setModalVisibleUser(false)}
        style={{ minWidth: "67rem" }}
        className="order-modal"
      >
        <div className="mb-6">
          <EditOrderUser
            onSuccessModal={() => {
              setModalVisibleUser(false);
            }}
            selectedUserEdit={selectedUser}
          />
        </div>
      </Modal>
    </>
  );
};

export default OrderCardEdit;
